import React from "react";
import { newIcon } from "../Icon";

export const CloseIcon = newIcon(
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1L7.5 7.5M14 14L7.5 7.5M7.5 7.5L14 1L1 14"
      stroke="#312B53"
      stroke-width="1.7"
    />
  </svg>,
  true
);
